module.exports = __webpack_public_path__ + "static/media/29-13.ea1b6c04.mp3";